import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { GENERAL_ENQUIRY, STORE } from "@/lib/store";

export const Footer = () => (
  <footer className="border-t border-[#E5E0D8] bg-[#F4EEE2] pb-28 pt-12 md:pb-12" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
      <div>
        <p className="font-display text-xl font-bold text-[#1B4332]">{STORE.name}</p>
        <p className="mt-1 text-sm text-[#5B625D]">{STORE.addressShort}</p>
      </div>
      <div className="flex items-center gap-5 text-sm">
        <a href={GENERAL_ENQUIRY} target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex items-center gap-2 font-semibold text-[#1B4332]" data-testid="footer-whatsapp-link"><MessageCircle className="h-4 w-4" /> WhatsApp us</a>
        <Link to="/admin/login" className="text-[#5B625D] hover:text-[#1B4332]" data-testid="footer-owner-login-link">Owner login</Link>
        <span className="text-[#5B625D]">© {new Date().getFullYear()}</span>
      </div>
    </div>
  </footer>
);
